import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import _404SectionHttpCodesLightReverse1 from '../components/http-codes-light-reverse/_404SectionHttpCodesLightReverse1';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function _404() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <_404SectionHttpCodesLightReverse1 />
    </React.Fragment>
  );
}

